export enum EGuestHomepageVersions {
  B = 'B',
  B2 = 'B2',
  C = 'C',
  C2 = 'C2',
}

export interface IWelcomePackageStrapi {
  id;
  title;
  subtitle;
  color;
  amount_spins;
  reg_type;
  image;
  description?: string;
  rank?: any;
}
